if (!window.Eurus.loadedScript.has('exhibition-recently-viewed.js')) {
  window.Eurus.loadedScript.add('exhibition-recently-viewed.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.store('xExhRecently', {
        productsToShow: 0,
        loaded: false,
        init() {
          const el = document.getElementById('shopify-section-exh-recently-viewed');
          if (el) {
            this.productsToShow = parseInt(el.getAttribute('x-products-to-show'), 10) || 4;
          }
        },
        hasHistory() {
          return !!(localStorage.getItem('recently-viewed')?.length);
        },
        load(sectionId) {
          if (this.loaded || !this.hasHistory()) return;
          this.loaded = true;

          let stored = [];
          try {
            stored = JSON.parse(localStorage.getItem('recently-viewed')).map(String);
          } catch (e) {
            return;
          }
          const products = stored.slice(0, this.productsToShow);
          if (!products.length) return;

          const el = document.getElementById('shopify-section-exh-recently-viewed');
          if (!el) return;

          let collectionIds = [];
          try {
            const idsEl = document.getElementById('exh-rv-collection-ids');
            collectionIds = (JSON.parse(idsEl?.textContent || '[]') || []).map(String);
          } catch (e) { /* fall back to recency-only order */ }

          const query = products.map((v) => 'id:' + encodeURIComponent(v)).join(' OR ');
          const searchUrl = `${Shopify.routes.root}search?section_id=${sectionId}&type=product&q=${query}`;

          fetch(searchUrl)
            .then((response) => {
              if (!response.ok) throw new Error(response.status);
              return response.text();
            })
            .then((text) => {
              const doc = new DOMParser().parseFromString(text, 'text/html');
              const target = doc.querySelector('#shopify-section-exh-recently-viewed');
              if (!target) return;

              // Search does not guarantee result order: re-sort slides so
              // pieces from the current collection come first, then by recency.
              const list = target.querySelector('.splide__list');
              if (list) {
                const rank = (pid) => {
                  const i = products.indexOf(pid);
                  return i < 0 ? 999 : i;
                };
                const slides = Array.from(list.children);
                slides
                  .sort((a, b) => {
                    const pa = String(a.getAttribute('data-exh-pid'));
                    const pb = String(b.getAttribute('data-exh-pid'));
                    const ca = collectionIds.includes(pa) ? 0 : 1;
                    const cb = collectionIds.includes(pb) ? 0 : 1;
                    return ca - cb || rank(pa) - rank(pb);
                  })
                  .forEach((slide) => list.appendChild(slide));
              }
              el.innerHTML = target.innerHTML;
            })
            .catch((error) => {
              console.log(error);
            });
        }
      });
    });
  });
}
